import { Button, Text } from "@pallet-hq/hegel"
import { useRouter } from "next/router"
import { FullPageDiv, InfoDiv } from "../shared/styles"

const NoPermissions = ({ message }: { message?: string }) => {
    const router = useRouter()

    return (
        <FullPageDiv>
            <InfoDiv>
                <Text variant="headlineMedium">
                    You don’t have permission to view this page!
                </Text>
                <br />
                <Text variant="paragraphMedium" color="gray600">
                    {message ||
                        "Think this is an error? Try making sure you’re signed into the right account, or contact us!"}
                </Text>
                <Button size="small" width={1} mt={3} onClick={router.back}>
                    Go back
                </Button>
            </InfoDiv>
        </FullPageDiv>
    )
}

export default NoPermissions
